import React from 'react';
export const CaseReviewRequestsContext = React.createContext(undefined);
export function useCaseReviewRequestsContext() {
    const result = React.useContext(CaseReviewRequestsContext);
    if (result === undefined) {
        throw new Error('useCaseReviewRequestsContext must be used within a CaseReviewRequestsContext');
    }
    return result;
}
